package link.erpango.quip.data.remote.repository.catalog

import link.erpango.quip.data.remote.ApiClient
import link.erpango.quip.data.remote.DResponse
import link.erpango.quip.data.remote.repository.IApiRepository

class CatalogRepository(
    override val api: ApiClient,
) : ICatalogRepository, IApiRepository<ApiClient> {
    override val resourcePath: String
        get() = "api/catalog"

    override suspend fun getCatalog(updatedSince: Long?): DResponse<CatalogResponseDto> {
        val path = if (updatedSince != null) {
            "$resourcePath/?updated_since=$updatedSince"
        } else {
            "$resourcePath/"
        }
        return api.consume(path)
            .get()
            .response(CatalogResponseDto.serializer())
    }
}
